// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"ed26c2353bdeab54","4203":"e1fa8eda8e4801b0","8470":"e3304a11b68203f1"}[chunkId] + ".css";
};